module.exports = __webpack_public_path__ + "static/media/site_administration.c78e1ff1.svg";